import {
  IDSK,
  CreateBankInput,
  ModelWorkspaceConnection,
  Workspace,
} from "@examspark/types";

import GraphQLAPI from "..";
import * as queries from "../queries/bank";

export const listBanks = async (workspaceId: string) => {
  const result = await GraphQLAPI.client.query<{
    listBanks: ModelWorkspaceConnection;
  }>({
    query: queries.listBanks`
    items {
      id
      sk
      name
      description
      createdAt
      updatedAt
      isDisabled
      isDeleted
    }
    nextToken
    `,
    variables: {
      input: {
        id: workspaceId,
      },
    },
  });

  return result.data?.listBanks;
};

export const updateBank = async (key: IDSK, data: Partial<Workspace>) => {
  const result = await GraphQLAPI.client.query<{ updateBank: Workspace }>({
    query: queries.updateBank`
      id
      sk
    `,
    variables: {
      input: {
        ...data,
        ...key,
      },
    },
  });

  return result.data?.updateBank;
};

export const getBankById = async (key: IDSK) => {
  const result = await GraphQLAPI.client.query<{ getWorkspace: Workspace }>({
    query: queries.getBank`
    id
    sk
    type
    name
    description
    createdAt
    updatedAt
    lastActiveAt
    features
    workspaceId
    workspaceUserId
    invitationId
    status
    customerId
    acl
    counter
    reviewCountPending
    isDisabled
    isDeleted
    recentResourceIds
    `,
    variables: {
      input: {
        id: key.id,
        sk: `bank#${key.sk}`,
      },
    },
  });

  return result.data?.getWorkspace;
};

export const createBank = async (
  data: Omit<CreateBankInput, "id" | "sk">,
  bankId: string,
) => {
  if (!data.workspaceId) {
    throw new Error("Invalid bank ID");
  }

  const result = await GraphQLAPI.client.query<{
    createBank: Workspace;
  }>({
    query: queries.createBank`
      id
      sk
      workspaceId
      createdAt
      updatedAt
    `,
    variables: {
      input: {
        id: `${data.workspaceId}`,
        sk: `bank#${bankId}`,
        name: data.name,
        description: data.description,
        workspaceId: data.workspaceId,
        schemaVersion: "2020-01-01",
      },
    },
  });

  return result.data?.createBank;
};
